import apiClient from "../apiClient";
import { FLIGHTS_ENDPOINTS } from "../endpoints/flights";

export const fetchFlightHome = async (params) => {
  try {
    const response = await apiClient.get(FLIGHTS_ENDPOINTS.home, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching flight home:", error);
    throw error;
  }
};

export const searchFlights = async (payload = {}) => {
  try {
    const response = await apiClient.post(FLIGHTS_ENDPOINTS.search, payload);
    return response.data;
  } catch (error) {
    console.error("Error searching flights:", error);
    throw error;
  }
};

export const fetchFlightRoutes = async (params) => {
  try {
    const response = await apiClient.get(FLIGHTS_ENDPOINTS.routes, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching flight routes:", error);
    throw error;
  }
};

export const fetchFlightOffers = async (params) => {
  try {
    const response = await apiClient.get(FLIGHTS_ENDPOINTS.offers, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching flight offers:", error);
    throw error;
  }
};
